import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6e05394"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6e05394')) {
      api.createRecord('f6e05394', component.options)
    } else {
      api.reload('f6e05394', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f6e05394", function () {
      api.rerender('f6e05394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Placeholder/index.vue"
export default component.exports